module.exports = __webpack_public_path__ + "img/brake.eb4e8599.svg";